import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer({ settings = {} }) {
  return (
    <footer className="footer">
      <div className="footer-inner container">
        <div className="footer-brand">
          <div className="footer-logo">ElevenNorth <span>&amp; Co.</span></div>
          <p className="footer-tagline">Factory direct wholesale fashion.<br/>Women, Men &amp; Children.</p>
        </div>
        <div className="footer-col">
          <div className="footer-heading">Catalogue</div>
          <Link to="/catalogue?category=women">Women</Link>
          <Link to="/catalogue?category=men">Men</Link>
          <Link to="/catalogue?category=children">Children</Link>
          <Link to="/catalogue">All Products</Link>
        </div>
        <div className="footer-col">
          <div className="footer-heading">Account</div>
          <Link to="/register">Register as Buyer</Link>
          <Link to="/login">Login</Link>
          <Link to="/account">My Orders</Link>
        </div>
        <div className="footer-col">
          <div className="footer-heading">Contact</div>
          <a href={`mailto:${settings.contact_email || 'info@elevennorth.com'}`}>{settings.contact_email || 'info@elevennorth.com'}</a>
          <a href={`tel:${settings.contact_phone || ''}`}>{settings.contact_phone || '+44 20 0000 0000'}</a>
          <Link to="/contact">Send a message</Link>
        </div>
      </div>
      <div className="footer-bottom container">
        <span>© {new Date().getFullYear()} ElevenNorth &amp; Co. All rights reserved.</span>
        <span>UK Wholesale Only</span>
      </div>
    </footer>
  );
}
